import { InfoWindow, Marker } from "@vis.gl/react-google-maps";
import { Avatar } from "antd";
import { EyeFilled } from "@ant-design/icons";
import moment from "moment";
import marker from "assets/images/emun_marker.png";
import { IDriverLocationData, IPassengerLocationData } from "models/location";

interface IProps {
  data: IPassengerLocationData | IDriverLocationData;
}

export default function TrackerMarker({ data }: IProps) {
  const isPassenger = "passenger_id" in data;
  const displayName = `${data.first_name} ${data.last_name}`;
  const tripStatus = data.has_ongoing_trip ? "On Trip" : "No Active Trip";

  return (
    <>
      <Marker
        optimized
        icon={{
          url: marker,
          scaledSize: new google.maps.Size(70, 70),
          rotation: data.heading ?? 0,
        }}
        position={{
          lat: data.latitude,
          lng: data.longitude,
        }}
      />
      <InfoWindow
        headerDisabled
        pixelOffset={[0, -70]}
        position={{
          lat: data.latitude,
          lng: data.longitude,
        }}
      >
        <div className="w-full flex flex-col gap-y-2">
          <div className="w-full flex items-center justify-start gap-x-3 relative">
            <div className="w-10 h-10 shadow-md rounded-full bg-gray-200 flex items-center justify-center">
              <span className="text-xl font-bold text-gray-600">
                {data.first_name.charAt(0)}
              </span>
            </div>
            <div className="w-full flex flex-col gap-y-0.5">
              <p className="font-bold whitespace-nowrap">{displayName}</p>
              <p className="flex items-center justify-start gap-x-2">
                <EyeFilled className="" />
                <span className="text-[10px] inline-block whitespace-nowrap">
                  {moment(data.last_update).format("lll")}
                </span>
              </p>
              <p className="text-[10px] text-gray-600">
                {tripStatus}
                {data.speed !== undefined && ` • ${Math.round(data.speed)} km/h`}
              </p>
            </div>
          </div>
        </div>
      </InfoWindow>
    </>
  );
}
